
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Asset, Workorder } from 'performo-api';

import AdvancedAssetPicker from '@/components/assets/AssetPicker.vue';

@Component({
  components: {
    AdvancedAssetPicker
  }
})
export default class AddAssetComponent extends Vue {
  @Prop({ required: false })
  private disabled!: boolean;

  @Prop({ required: true })
  private order!: Workorder;

  @Prop({})
  startingAssets!: Asset[];

  private pickedAssets!: Asset[];
  private scannedCode = '';

  data() {
    return {
      pickedAssets: []
    };
  }

  async mounted() {
    this.pickedAssets = [];
  }

  returnPicks() {
    this.$emit('picks-changed', this.pickedAssets);

    this.cancelAsset();
  }

  cancelAsset() {
    this.pickedAssets = [];
    this.popoverOpen = false;
  }
  private popoverOpen = false;
}
